import { BIGRAM_REGEXP } from './constants';

export default function getBigramFromUrl(url: string) {
  const urlWithoutParams = url.split('?')[0];
  const tokens = urlWithoutParams.split('/').filter(Boolean);

  return tokens.find(token => BIGRAM_REGEXP.test(token)) ?? null;
}
